import React, { useState } from "react";

import { Calendar } from "react-date-range";
import {
  addDays,
  format,
  isWeekend,
  addYears,
  subYears,
  subDays,
} from "date-fns";
import "../report-styles/dateRangePicker.scss";

export default function DateRangePicker({
  onChangeDate,
  minDate,
  maxDate,
  hideDatePicker,
  date,
  showMonthAndYearPickers = true,
}) {
  const [state, setState] = useState(null);

  function customDayContent(day) {
    var extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: "5px",
            width: "5px",
            borderRadius: "100%",
            background: "#e91e63",
            position: "absolute",
            top: 2,
            right: 2,
          }}
        />
      );
    }
    return (
      <div>
        <span>{format(day, "d")}</span>
      </div>
    );
  }
  const effectiveMaxDate = maxDate;

  return (
    <div className="date-range-picker-container">
      <Calendar
        onChange={(item) => {
          console.log("Calendar onChange:", item);
          setState(item);
          onChangeDate(item);
        }}
        showMonthAndYearPickers={showMonthAndYearPickers}
        showMonthArrow={true}
        date={date === "" ? null : new Date(date)}
        color={"#e31c74"}
        minDate={minDate ? new Date(minDate) : subYears(new Date(), 60)}
        maxDate={
          effectiveMaxDate
            ? new Date(effectiveMaxDate)
            : addYears(new Date(), 1)
        }
      />
    </div>
  );
}
